import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {accessConstants, authUtils, ReloadListAction} from "mindsets-js-sdk";
import {DeleteDashboardAction} from "../../actions/dashboard_actions";


const DeleteButton = function ({id}) {
    const me = useSelector(state => state.me);
    const dispatch = useDispatch();
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_PROJECTS])) {
        return (
            <button
                className='button red'
                onClick={() => {
                    if (confirm('Are you sure you want to delete this Dashboard?')) {
                        dispatch(DeleteDashboardAction(id)).then(() => dispatch(ReloadListAction(true, 'dashboards')));
                    }
                }}
            >
                <i className='fas fa-trash'/>
            </button>
        );
    }

    return null;
}

DeleteButton.propTypes = {
    id: PropTypes.number.isRequired
}

export default DeleteButton;
